import React from 'react';
import { RoadmapPreviewResponse } from '../roadmapPreviewService';

export default function RoadmapPreviewLayoutWeb(props: {
  preview: RoadmapPreviewResponse;
}) {
  return (
    <div
      style={{
        padding: '30px 40px',
        maxHeight: '70vh',
        overflowY: 'auto',
        backgroundColor: '#fafbfc',
      }}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '8px',
          padding: '24px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        }}
      >
        <h2
          style={{
            marginBottom: '20px',
            fontSize: '18px',
            fontWeight: '600',
            color: '#1a1a1a',
            lineHeight: '1.4',
            borderBottom: '2px solid #e5e7eb',
            paddingBottom: '12px',
          }}
        >
          {props.preview.taskName}
        </h2>
        <div
          style={{
            fontSize: '15px',
            lineHeight: '1.7',
            color: '#374151',
          }}
          dangerouslySetInnerHTML={{ __html: props.preview.description }}
        />
      </div>
    </div>
  );
}
